import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./app.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./app.component.scss?ngResource";
import { ChangeDetectorRef, Component, HostListener } from "@angular/core";
import { AuthService } from "./shared/services/auth/auth.service";
import { AppControllerService } from "./app-controller.service";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { UserInformationService } from "./shared/services/user/user-information.service";
import { AppConfig } from "./app.config";
import { RequestStatusService } from "./shared/services/request-status/request-status.service";
import { SystemModuleSettingsService } from "./shared/services/system-module-settings.service";
import { ServerNotificationService } from "./shared/services/server-notification/server-notification.service";
import { WebNotificationService } from "./shared/services/web-notification/web-notification.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "./shared/services/storage/local-storage.service";
import { LocalStorageEnum } from "./shared/services/storage/local-storage-constants";
import { LocationStrategy } from "@angular/common";
import { AutoUnsub } from "./shared/decorators/autounsub.decorator";
import { AflaCommonService } from "../../../afla-common/src/lib/afla-common.service";
import { Title } from "@angular/platform-browser";
import { OrganisationRoutingConstants } from "./core/organisations/organisation-settings-routing.constants";
let AppComponent = class AppComponent {
    appController;
    authService;
    windowReference;
    bottomSheet;
    userInformationService;
    appConfig;
    requestStatusService;
    systemModuleSettingsService;
    webNotificationService;
    serverMessageService;
    router;
    localStorage;
    url;
    aflaCommonService;
    changeDetectorRefs;
    titleService;
    /*   branding: IBranding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR
      }; */
    branding = {
        themeMainColor: null,
        themeMainDarkerColor: null,
        themeMainBackgroundColor: null,
        themeMainBorderColor: null,
        themeHeaderBorderColor: null,
        themeActiveColor: null,
        themeActiveAlternateColor: null,
        themeLogoBackgroundColor: null,
        themePrimaryButtonColor: null
    };
    mapCenter = [-122.4194, 37.7749];
    basemapType = "satellite";
    mapZoomLevel = 12;
    $isAuthenticated;
    $userInformationFetched;
    showBusyIndicator = false;
    isMobileDevice = false;
    deferredPromptEvent;
    ON_SAME_RELOAD_STRATEGY = "reload";
    loadPublicCaptureComment = false;
    loadPublicViewDocuments = false;
    messageReceivedSubscription;
    updateDevice() {
        // lg (for laptops and desktops - screens equal to or greater than 1200px wide)
        // md (for small laptops - screens equal to or greater than 992px wide)
        // sm (for tablets - screens equal to or greater than 768px wide)
        // xs (for phones - screens less than 768px wide)
        if (window.innerWidth >= 1200) {
            this.appController.updateIsMobileDevice(false); // lg
        }
        else if (window.innerWidth >= 992) {
            this.appController.updateIsMobileDevice(false); // md
        }
        else if (window.innerWidth >= 768) {
            this.appController.updateIsMobileDevice(true); // sm
        }
        else if (window.innerWidth < 768) {
            this.appController.updateIsMobileDevice(true); // xs
        }
    }
    constructor(appController, authService, windowReference, bottomSheet, userInformationService, appConfig, requestStatusService, systemModuleSettingsService, webNotificationService, serverMessageService, router, localStorage, url, aflaCommonService, changeDetectorRefs, titleService) {
        this.appController = appController;
        this.authService = authService;
        this.windowReference = windowReference;
        this.bottomSheet = bottomSheet;
        this.userInformationService = userInformationService;
        this.appConfig = appConfig;
        this.requestStatusService = requestStatusService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.webNotificationService = webNotificationService;
        this.serverMessageService = serverMessageService;
        this.router = router;
        this.localStorage = localStorage;
        this.url = url;
        this.aflaCommonService = aflaCommonService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.titleService = titleService;
        this.saveUrl();
        this.startAuthenticationProcess();
        this.setupPwaInstall(windowReference);
    }
    updateBusyIndicator(value) {
        if (this.showBusyIndicator !== value) {
            this.showBusyIndicator = value;
        }
    }
    // See app.component.html
    mapLoadedEvent(status) {
        this.appController.showConsoleMessage("The map loaded: " + status);
    }
    ngOnInit() {
        if (this.url.path().includes('/unsecure/captureComment')) {
            this.loadPublicCaptureComment = true;
            this.listenForBusySpinnerChanges();
            this.setRouterReloadStrategy();
        }
        else if (this.url.path().includes('/unsecure/viewDocuments')) {
            this.loadPublicViewDocuments = true;
            this.listenForBusySpinnerChanges();
            this.setRouterReloadStrategy();
        }
        else {
            this.loadPublicCaptureComment = false;
            this.loadPublicViewDocuments = false;
            this.$userInformationFetched = this.userInformationService.$userInformationFetched;
            this.$isAuthenticated = this.authService.$isAuthenticated;
            this.listenForBusySpinnerChanges();
            this.setRouterReloadStrategy();
        }
    }
    saveUrl() {
        const strings = window.location.href.split(window.location.host);
        const url = strings[strings.length - 1];
        // if (!this.localStorage.get(LocalStorageEnum.Url) && !url.includes("#id_token=")) {
        //   this.localStorage.set(LocalStorageEnum.Url, url);
        // }
        if (!url.includes("#id_token=")) {
            this.localStorage.set(LocalStorageEnum.Url, url);
        }
    }
    startAuthenticationProcess() {
        this.loadAppConfig(() => {
            const loggedIn = this.authService.checkIfLoggedIn();
            if (!loggedIn && this.url.path().includes('/unsecure/captureComment')) {
                this.loadPublicCaptureComment = true;
                this.listenForBusySpinnerChanges();
                this.setRouterReloadStrategy();
            }
            else if (!loggedIn && this.url.path().includes('/unsecure/viewDocuments')) {
                this.loadPublicViewDocuments = true;
                this.listenForBusySpinnerChanges();
                this.setRouterReloadStrategy();
            }
            else {
                this.loadPublicCaptureComment = false;
                this.authenticate();
            }
            this.titleService.setTitle(AppConfig.settings.projectSettings.title);
        });
    }
    loadAppConfig(appConfigLoadedAction) {
        this.appConfig.load().then(() => {
            appConfigLoadedAction();
            if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
                this.branding = AppConfig.settings.projectSettings.styling;
            }
            this.aflaCommonService.setThemeColors(this.branding);
            this.changeDetectorRefs.detectChanges();
        });
    }
    authenticate() {
        this.authService.authenticate().then((result) => {
            // this.redirectToDefaultLink();
            this.handleUserLoggedIn();
        });
    }
    setupPwaInstall(windowReference) {
        windowReference.nativeWindow.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            this.deferredPromptEvent = event;
            // TODO: Re-add this
            // const bottomSheetRef = this.bottomSheet.open(PwaInstallBottomSheetComponent);
            // bottomSheetRef.afterDismissed()
            //   .pipe(takeUntil(this.ngUnsubscribe))
            //   .subscribe((result) => {
            //     if (result) {
            //       this.promptInstallPWA();
            //     }
            //   });
        });
    }
    promptInstallPWA() {
        this.deferredPromptEvent.prompt();
    }
    listenForBusySpinnerChanges() {
        this.requestStatusService.$requestBusy.subscribe(value => {
            this.showBusyIndicator = value;
        });
    }
    handleUserLoggedIn() {
        this.listenForServerMessages();
    }
    listenForServerMessages() {
        this.messageReceivedSubscription = this.serverMessageService.messageReceived.subscribe((message) => {
            // TODO Dylan update this
            this.webNotificationService.showNotification("Message received", message);
        });
    }
    setRouterReloadStrategy() {
        this.router.onSameUrlNavigation = this.ON_SAME_RELOAD_STRATEGY;
    }
    busySpinnerDoubleClick() {
        this.requestStatusService.printBusyIndicators();
    }
    redirectToDefaultLink() {
        if (this.localStorage.get(LocalStorageEnum.Url)) {
            let url = this.localStorage.get(LocalStorageEnum.Url).toString();
            // this.localStorage.set(LocalStorageEnum.Url, null);
            // this.localStorage.remove(LocalStorageEnum.Url);
            url = url.replace(/"/g, "");
            url = url.replace("/afla", "");
            // if (this.extractOrganizationId(url))
            //   this.router.navigateByUrl(url);
            // if (this.extractModulId(url))
            //   this.router.navigateByUrl(url);
            var isOrg = this.extractOrganizationId(url);
            var isStep = this.extractModulId(url);
        }
    }
    extractOrganizationId(url) {
        const urlArray = url.split("/");
        const organisationId = +urlArray[1];
        const organisationRoute = urlArray[2];
        if (organisationRoute === OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE.replace("-", "") && organisationId) {
            this.appController.selectedOrganisationID(organisationId);
            return true;
        }
        return false;
    }
    extractModulId(url) {
        const urlArray = url.split("/");
        const moduleId = +urlArray[1];
        const stepId = urlArray[5];
        if (stepId && urlArray[4] == "step") {
            const stepId = urlArray[5];
            this.appController.updateStepToLoad(stepId);
        }
        if (moduleId) {
            this.appController.setSelectedModule(moduleId);
            return true;
        }
        return false;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: AuthService },
        { type: WindowReference },
        { type: MatBottomSheet },
        { type: UserInformationService },
        { type: AppConfig },
        { type: RequestStatusService },
        { type: SystemModuleSettingsService },
        { type: WebNotificationService },
        { type: ServerNotificationService },
        { type: Router },
        { type: LocalStorageService },
        { type: LocationStrategy },
        { type: AflaCommonService },
        { type: ChangeDetectorRef },
        { type: Title }
    ];
    static propDecorators = {
        updateDevice: [{ type: HostListener, args: ["window:resize", [],] }]
    };
};
AppComponent = __decorate([
    Component({
        selector: "app-root",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AppComponent);
export { AppComponent };
